import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

// Helpers
import { findPredicateById } from '../helpers';

const getParentUuids = ({ predicate, predicates }) => {
    if (!predicate.parentPredicateId) return [];
    const parentPredicate = findPredicateById({ predicates, predicateId: predicate.parentPredicateId });

    return [parentPredicate.uuid, ...getParentUuids({ predicates, predicate: parentPredicate })];
};

export const useCriteriaStoreAcceptDropPredicateUuids = (uuid) => {
    if (!uuid) return null;
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const predicates = useStore(store, (s) => s.predicates);
    const targetPredicate = predicates[uuid];
    const childUuids = targetPredicate?.predicates;
    const parentUuids = getParentUuids({ predicate: targetPredicate, predicates });

    return Object.entries(predicates).reduce((acc, [key, predicate]) => {
        return predicate?.predicateType &&
            ['Predicate', 'PredicateGroup'].includes(predicate?.predicateType) &&
            !childUuids.includes(key) &&
            !parentUuids.includes(key) &&
            key !== targetPredicate?.uuid
            ? [...acc, key]
            : acc;
    }, []);
};
